import { RelatedItemTag, RelatedItem as RelatedItemType } from '@layouts/Related/Related.types';
import React, { useState, useEffect, useMemo } from 'react';
import { RelatedItem } from './RelatedItem';

// Id used for showing all items
const offset = 4;
const defaultOffset = 4;
const perRow = 4;

interface RelatedListProps {
  filterTag?: RelatedItemTag;
  items?: RelatedItemType[];
  onRelatedItemClick?: (item: RelatedItemType) => void;
  styleType: string;
  i18n: Record<string, string>;
}

export const RelatedList = ({
  filterTag = { id: 0, name: 'All' },
  onRelatedItemClick,
  items = [],
  styleType,
  i18n,
}: RelatedListProps) => {
  const [maxItemsVisible, setMaxItemsVisible] = useState(defaultOffset);

  const filteredList = useMemo(() => {
    if (filterTag.id === 0) {
      return items || [];
    }

    return items.filter((item) => {
      if (!item.Tags) return false;

      const itemTags = item.Tags.map(tag => tag?.id) || [];
      return itemTags?.includes(filterTag.id);
    });
  }, [filterTag.id]);
  
  useEffect(() => {
    setMaxItemsVisible(defaultOffset);
  }, [filterTag.id]);

  const showMore = () => {
    setMaxItemsVisible((value) => value + offset);
  };

  return filteredList.length > 0 ? (
    <div className='is-bound'>
      <div className='l-products-list-container'>
        <div className='l-products-list'>
          {filteredList
            .filter((_item, index) => index < maxItemsVisible)
            .map((item, index) => {
              return (
                <div
                  key={index}
                  className={`l-products-list-item  ${perRow ? `is-${perRow}` : ''}`}
                >
                  <RelatedItem onClick={onRelatedItemClick} className={styleType} item={item} />
                </div>
              );
            })}
        </div>
      </div>
      {maxItemsVisible < filteredList.length && (
        <div className='l-show-more-btn'>
          <button className='c-button is-primary is-medium is-upper-case' onClick={showMore}>
            {i18n.ShowMore || 'Show more'}
          </button>
        </div>
      )}
    </div>
  ) : null;
};
